<template>
    <div class="info-container container containerBox clearfix">
        <el-form :inline="true" :model="houseSearchsForm" class="hold-search-form">
            <el-form-item :label="$t('household.holdStatus')">
                <el-select v-model="houseSearchsForm.HouseholdStatus" :placeholder="$t('message.pSelect')" size="medium" clearable>
                    <el-option v-for="(v, i) in LesseeStatusConfig" :key="i" :label="v.label" :value="v.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('household.selectRes')" prop="residenceOID">
                <cmp-build-select 
                    :buildRoom="buildRoom"
                    changeOnSelect
                    @listenBuildResult="listenBuildResult"></cmp-build-select>                   
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleSearch" size="medium">{{$t('btns.search')}}</el-button>
                <!-- <el-button @click="onSubmit" size="medium">导出</el-button> -->
            </el-form-item>
        </el-form>

        <div class="add-household-box">
            <el-button type="primary" size="medium" @click="addHouseHold" v-has="'business_owner'">+ {{$t('household.addHold')}}</el-button>
        </div>
        <el-alert class="tips-box" :closable="false" type="success" title="">
			<!-- 业主总数 -->
            <span class="tips-item">{{$t('household.holdTotal')}}：</span><span class="tips-item">{{lessee.total}}，</span>
			<!-- 正常业主 -->
            <span class="tips-item">{{$t('household.holdNormal')}}：</span><span class="tips-item">{{lessee.normal}}，</span>
			<!-- 已销户 -->
            <span class="tips-item">{{$t('household.holdCancel')}}：</span><span class="tips-item">{{lessee.cancal}}</span>
        </el-alert>
		
        <el-table 
		:data="infoTable" 
		type="index" 
		:expand-row-keys="expands" 
		:row-key="getRowKeys" style="width: 100%" 
		@expand-change="expandchange">
		
            <el-table-column type="expand" >
                <template slot-scope="props">
                    <el-form label-position="left" inline class="demo-table-expand">
                        <el-form-item :label="$t('household.sex')" v-show="props.row.id_card != 3">
                            <span>：{{ props.row.sex == 1 ? "男" : "女" }}</span>
                        </el-form-item>
                        <el-form-item :label="$t('household.telephone')">
                            <span>：{{ props.row.telephone }}</span>
                        </el-form-item>
                        <el-form-item :label="$t('household.email')">
                            <span>：{{ props.row.email }}</span>
                        </el-form-item>
                        <el-form-item :label="$t('household.IDCard')">
                            <span>：{{ transInfo( props.row.id_card ,'IDCard') }}</span>
                        </el-form-item>
                        <el-form-item :label="$t('household.IDNum')">
                            <span>：{{ props.row.id_num }}</span>
                        </el-form-item>
						<el-form-item label="房间号">
						    <span>：{{housenames}}</span>
						</el-form-item>
						<el-form-item label="开户时间">
						    <span>：{{ props.row.create_date }}</span>
						</el-form-item>
                        <!-- <el-form-item :label="$t('household.payType')">
                            <span>{{ getTrans( props.row.payType ,'payType') }}</span>
                        </el-form-item> -->
                        <!-- <el-form-item :label="$t('household.depositBank')">
                            <span>{{ props.row.depositBank }}</span>
                        </el-form-item> -->
                        <!-- <el-form-item :label="$t('household.payNum')">
                            <span>{{ props.row.payNum}}</span>
                        </el-form-item> -->
                        <!-- <el-form-item :label="$t('household.deviceStatus')">
                            <span>{{ getTrans( props.row.deviceStatus ,'deviceStatus') }}</span>
                        </el-form-item> -->
                        <!-- <el-form-item :label="$t('household.resAddress')">
                            <span>{{ getTransAdress( props.row.levelList) }}</span>
                        </el-form-item> -->
                    </el-form>
                </template>
            </el-table-column>
            
            <!-- <el-table-column label="住宅面积" prop="residenceArea">
            </el-table-column> -->
            <!-- 业主名称 -->
            <el-table-column label="业主名称" prop="name">
            </el-table-column>
            <!-- 业主状态 -->
            <el-table-column :label="$t('household.holdStatus')">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.household_status === 1 ? 'success': 'danger'">{{transHouseholdStatus(scope.row)}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column v-if="sysid != 2" label="余额" prop="balance">
            </el-table-column>
           
            <!-- <el-table-column :label="$t('household.expenseType')" prop="expenseType" :formatter="transName">
            </el-table-column> -->
            <!-- <el-table-column :label="$t('household.discount')" prop="discount">
            </el-table-column> -->
            <!-- <el-table-column :label="$t('household.remain')" prop="remain">
            </el-table-column> -->
            <el-table-column :label="$t('btns.operate')">
                <template slot-scope="scope">
					<el-button v-if="sysid != 2 && scope.row.household_status === 1" @click="handleEditin(scope.row)"  v-has="'business_owner'" type="text">充值</el-button>
					<el-button v-if="sysid != 2 && scope.row.household_status === 1" @click="handleEditout(scope.row)"  v-has="'business_owner'" type="text">提现</el-button>
					<el-button v-if="sysid != 2" @click="handlebalancechange(scope.row)"  v-has="'business_owner'" type="text">查询流水</el-button>
                    <el-button v-if="scope.row.household_status === 1" @click="handleEdit(scope.row)"  v-has="'business_owner'" type="text">{{$t('btns.verify')}}</el-button>
                    <el-button v-if="sysid != 2 && scope.row.household_status === 1" @click="handleLogoff(scope.row)"  v-has="'business_owner'" type="text">{{scope.row.household_status == 1 ? "强制销户": "开户"}}</el-button>
					<el-button v-if="scope.row.household_status === 1" @click="handleoff(scope.row)"  v-has="'business_owner'" type="text">正常销户</el-button>
                </template>
            </el-table-column>
        </el-table>
<!--        <div style="float:right; padding-top: 24px" v-if="total > pageSize">
            <el-pagination :page-size="pageSize" background layout="prev, pager, next" :total="total" @current-change="currentChange">
            </el-pagination>
        </div> -->
        <el-dialog :title="$t('btns.verify')" :visible.sync="dialogVisible">
            <cmp-lessee-form :itemData="itemData" v-if="dialogVisible"></cmp-lessee-form>
        </el-dialog>

        <!-- 开户弹框 -->
        <el-dialog
        title="开户"
        :visible.sync="dialogVisibleKH"
        width="50%">
            <el-form style="min-height:200px;">
                <el-form-item label="请选择房间号" label-width="150px">
                    <!-- <cmp-build-selectbind v-if="dialogVisibleKH" :buildRoom="{}" selectType="HouseHoldID" @listenBuildResult="listenBuildResultHK"></cmp-build-selectbind> -->
					<cmp-build-selectbind  v-if="dialogVisibleKH" :buildRoom="{}" selectType="householdid" @listenBuildResult="listenBuildResult"></cmp-build-selectbind>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleKH = false">取 消</el-button>
                <el-button type="primary" @click="handleSaveKH">确 定</el-button>
            </span>
        </el-dialog>
		
		<!-- 充值弹框 -->
		<el-dialog
		:title="titlein"
		:visible.sync="dialogin"
		width="500px">
		<el-form :model="payform" label-width="100px" style="margin:0 auto;width:400px;">
				<el-form-item label="充值金额">
					<el-input v-model.number="payform.money"></el-input>
				</el-form-item>
				<el-form-item label="支付方式">
					<el-select v-model="payform.pay_type" placeholder="请选择支付方式">
					  <el-option label="支付宝" value="1"></el-option>
					  <el-option label="微信" value="2"></el-option>
					  <el-option label="银联" value="3"></el-option>
					  <el-option label="现金" value="4"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		    <span slot="footer" class="dialog-footer">
		        <el-button @click="dialogin = false">取 消</el-button>
		        <el-button type="primary" @click="handleSavein">确 定</el-button>
		    </span>
		</el-dialog>
		
		
    </div>
</template>

<script>
import Storage from '@/utils/storage'
import CmpLesseeForm from "./CmpLesseeForm/CmpLesseeForm";
import CmpBuildSelect from '@/components/CmpBuildSelect/CmpBuildSelect'
import CmpBuildSelectbind from '@/components/CmpBuildSelect/CmpBuildSelectbind'
import Service from '@/api/Service'
import { getHouseName,getHouseNames,$Alert,$Alertnew } from '@/utils/utils'
import { IDCARD, LESSEESTATUS } from '@/api/configData'
import { mapGetters } from "vuex";

export default {
    name: "lesseemana",
    inject: ["reload"],
    data() {
        return {
            // 查询表单
            houseSearchsForm: {
                HouseholdStatus: "",
                oid: 0,
				is_house:false
            },
			titlein:'',
			isgod:false,
			//充值表单
			payform:{
				money:0,
				pay_type:''
			},
            // 选择房间组件
            buildRoom: {},
			sysid:null,
            LesseeStatusConfig: LESSEESTATUS,   //  租户状态 1开户，2销户

            lessee: {   //  业主总览
                total: 0,
                normal: 0,
                cancal: 0
            },

            infoTable: [],  //  业主列表
            expands: [], // 默认展开
			getRowKeys (row) {
              return row.oid
            },
            dialogVisible: false,   //  修改业主信息
			dialogin:false, //充值
            itemData: {},  
            // 开户框
            dialogVisibleKH: false, 
            KH_OID: "",
            KH_houseIDs: [],
			housenames:''
        };
    },
	computed: {
	    ...mapGetters(['projectsystemInfo']),

	},
    components: {
        CmpLesseeForm,
        CmpBuildSelect,
        CmpBuildSelectbind
    },
	created() {
		this.sysid = Storage.get('ProjectSystemInfo').projectsystemInfo.sys_type_id
	},
    mounted() {
        // 获取业主
        this.getLesseeList(this.houseSearchsForm);
    },
    methods: {
		async expandchange(row,expandedRows){
			var that = this
			if (expandedRows.length) {
				that.expands = []
				if (row) {
				that.expands.push(row.oid)
				}
			} else {
				that.expands = []
			}
			let data = await Service.getLesseeHouseList({householdid:row.oid})
			if(data && data != 'success' ){
				let Name = getHouseNames(data);
				this.housenames = Name
				// row.housename = Name
			}else{
				this.housenames = ''
			}		
		},
        async getLesseeList(params) {
            let data = await Service.getLesseeList(params);
            if(data && data != 'success') {
                this.infoTable = data
            }else{
                this.infoTable = []
            }
            this.fmtListData();
        },
        fmtListData() {
            let total = this.infoTable.length;
            let normal = this.infoTable.filter(v=> v.household_status === 1).length
            let cancal = total - normal;
            this.lessee = {total, normal, cancal}
        },
        // 选择房间组件
        open() {
            this.buildRoom = {}
        },
		handlebalancechange(row){
			this.$router.push("/household/balancechange/" + row.oid);
		},
        // 最后一级房间确认信息
        listenBuildResult(data) {
			if(data.householdid === undefined) {
			    // 建筑
			    this.houseSearchsForm.is_house = false
			}else{
			    // 房间
			    this.houseSearchsForm.is_house = true
			}
            this.houseSearchsForm.oid = data.oid;
			this.KH_houseIDs = data;
        },
        // 开户
        listenBuildResultHK(data) {
			
            this.KH_houseIDs = data;
        },
        // 查询租户
        handleSearch(){
            let obj = Object.assign({}, this.houseSearchsForm)
            // if(obj.oid>0) {
            //     obj.HouseholdStatus = 1
            // }
            this.getLesseeList(obj);
        },
        // 添加业主
        addHouseHold() {
            this.$router.push("/household/add");
        },
        // 修改租户信息
        async handleEdit(row) {
            // 获取房间信息
            let data = await Service.getLesseeHouseList({householdid:row.oid});
            if(data) {
                data = data === 'success' ? [] : data;
                let houseName = getHouseName(data);
                // 显示修改弹框
                this.itemData = row;
                this.itemData.choseHouseList = data;
                this.itemData.houseName = houseName;
                this.dialogVisible = true;
            }
            
        },
		//强制销户
		async handleoff(row){
			this.isgod = true
			this.handleLogoff(row)
		},
        // 销户
        async handleLogoff(row) {
			if(row.household_status == 1) {
				let data = await Service.getLastHold({household_id:row.oid})
				if(this.sysid !=0 || data == null || data == 'success'){
					$Alert(`是否确认销户?`).then( async (bool)=>{
						if(bool == '1'){
								// 销户
								let data
								if(this.isgod){
									data = await Service.deleteLes({OID: row.oid});
									this.isgod =false
								}else{
									data = await Service.deleteLessee({OID: row.oid});
								}
								if(data) {
									this.$message({
										type: 'success',
										message: '操作成功!',
										duration: 1500,
										onClose: ()=>{
											this.reload();
										}
									});
								}
						}  
					});					
				}else{
					$Alertnew(`该业主绑定的房间中有未生成的账单，是否确认销户?`).then( async (bool)=>{
						if(bool == '1'){
								// 销户
								let data
								if(this.isgod){
									data = await Service.deleteLes({OID: row.oid});
									this.isgod =false
								}else{
									data = await Service.deleteLessee({OID: row.oid});
								}
								if(data) {
									this.$message({
										type: 'success',
										message: '操作成功!',
										duration: 1500,
										onClose: ()=>{
											this.reload();
										}
									});
								}
						}else if(bool == '0'){
							this.$router.push({ path: "/readingmeter" });
						}else{
							
						}
					});	
				}
				}else{
							// 开户
							this.dialogVisibleKH = true;
							this.KH_OID = row.oid
						}
            
        },
        // 重新开户
        async handleSaveKH() {
            let obj = {};
            obj.oid = this.KH_OID;
            obj.houseidlist = [];
            this.KH_houseIDs.map(v=>{
                obj.houseidlist.push({oid: v.oid + ""})
            })
            let data = await Service.updataMultiLessee(obj);
            if(data) {
                this.$message({
                    type: 'success',
                    message: '操作成功!',
                    duration: 1500,
                    onClose: ()=>{
                        this.reload();
                    }
                });
            }
        },
		handleEditin(row){
			this.titlein="充值"
			this.payform.household_id =row.oid
			this.dialogin = true;
		},
		handleEditout(row){
			this.titlein="提现"
			this.payform.household_id =row.oid
			this.dialogin = true;
		},
		//充值
		async handleSavein(){
			if(this.payform.money < 0){
				this.$message({
				    type: 'warn',
				    message: '请输入正确金额！！！!',
				    duration: 1500,
				});
				return
			}
			let obj = Object.assign({}, this.payform)
			let data
			if(this.titlein === "充值"){
				data = await Service.recharge(obj);
			}else{
				data = await Service.withdrawdeposit(obj);
				
			}
			if(data) {
			    this.$message({
			        type: 'success',
			        message: '操作成功!',
			        duration: 1500,
			        onClose: ()=>{
			            this.reload();
			        }
			    });
			}
		},
        toEquipmentControl(row) {
            this.getMeterInfo(row.HouseID)
        },
        // 获取租户表计信息
        async getMeterInfo(id) {
            let data = await Service.getHouseInfo({oid: id});   //  根据房间ID获取表计ID
            data = data === 'success' ? [] : data;
            if(data.length>0) {
                let meter = await Service.getMeterInfo({oid: data[0].terminalid});  //  根据表计ID获取表计类型               
            }
            return
            // 
            //this.$router.push('/equipmentControl/wkqInfo/'+ row.terminalid)
            // 
            //this.$router.push('/equipmentControl/fgInfo/'+ row.terminalid)
        },
        // 业主状态
        transHouseholdStatus(row) {
            switch (row.household_status) {
                case 1:
                    return '正常'
                case 2:
                    return '销户'
                default:
                    return ''
            }
        },
        // 格式化
        transInfo(val, type) {
            switch (type) {
                case 'IDCard':
                    // 身份证类型
                    return this.fmtIDCard(val)
                    break;
                default:
                    break;
            }
        },
        // 证件类型
        fmtIDCard(val) {
            let str = ''
            for (let i = 0; i < IDCARD.length; i++) {
                const v = IDCARD[i];
                if(v.value === val) {
                    str = v.label;
                    break;
                }
            }
            return str
        }
    }
};
</script>
<style>
.hold-search-form .el-input {
    width: 350px;
}
.info-container .el-dialog  {
    width: 700px;
}
</style>

<style scoped>
.info-container .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: calc(100% / 3);
}
.info-container .el-table th {
    color: rgba(0, 0, 0, 0.85);
    font-weight: normal;
    background: #fafafa;
}
.info-container .el-alert--success {
    background-color: #e6f7ff;
    color: #333;
}
</style>

<style scoped>

.add-household-box,
.tips-box {
    margin: 0 0 24px;
}

.tips-item {
    padding-right: 4px;
}
</style>
